// DS: C25A
import React from 'react';
import classnames from 'classnames';
import ArrowDownIcon from '@wix/da-ds/pkg/Icons/ArrowDown';
import shortenNumber from '@wix/da-ds/pkg/utils/shortenNumber';
import {
  PopperDropdownManager,
  PopperDropdownToggle,
  PopperDropdownContent,
} from '@wix/da-ds/pkg/Dropdown/PopperDropdownLayout';
import FolderDropdownDesktopMenu from './FolderDropdownDesktopMenu';
import { Props } from '../types';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import s from './FolderDropdownDesktop.scss';

const FolderDropdownDesktop: React.FC<React.PropsWithChildren<Props>> = ({
  id,
  folderNameClassNames,
  currentFolder,
  arrowIconSize = IconSize.SMALL,
  className,
  usePortal,
  folders,
  disabled,
  setSelectedFolderId,
  renderToggle,
  escapeScreenSpace = true,
  hasMore,
  fetchMore,
  hasLess,
  fetchLess,
  isLoading,
}) => {
  const classNames = classnames(
    s['root'],
    'no-theme-skin',
    disabled && s['disabled'],
    className
  );
  return (
    <div className={classNames}>
      <PopperDropdownManager isInPopup>
        <PopperDropdownToggle className={s['toggle']}>
          {renderToggle ? (
            renderToggle({ currentFolder })
          ) : (
            <>
              <div
                className={classnames(
                  s['selected-folder-name'],
                  folderNameClassNames
                )}
              >
                {currentFolder && currentFolder.name}
                <span className={s['count']}>
                  {shortenNumber(
                    currentFolder?.totalItemCount ?? currentFolder?.size ?? 0
                  )}
                </span>
              </div>
              <ArrowDownIcon className={s['caret']} size={arrowIconSize} />
            </>
          )}
        </PopperDropdownToggle>
        <PopperDropdownContent
          usePortal={usePortal}
          placement="bottom-start"
          allowFlip={false}
        >
          <FolderDropdownDesktopMenu
            id={id}
            folders={folders}
            setSelectedFolderId={setSelectedFolderId}
            currentFolder={currentFolder}
            hasMore={hasMore}
            fetchMore={fetchMore}
            hasLess={hasLess}
            fetchLess={fetchLess}
          />

          {isLoading && <LoadingIndicator coverMode view="llama" />}
        </PopperDropdownContent>
      </PopperDropdownManager>
    </div>
  );
};
FolderDropdownDesktop.displayName = 'FolderDropdownDesktop';

export default FolderDropdownDesktop;
